import { toast as sonnerToast } from 'sonner';

type ToastProps = {
  title?: string;
  description: string;
  variant?: 'default' | 'destructive';
};

export const toast = ({ title, description, variant = 'default' }: ToastProps) => {
  if (variant === 'destructive') {
    sonnerToast.error(description, {
      position: 'top-right',
    });
  } else {
    sonnerToast(description, {
      position: 'top-right',
    });
  }
};
